import React from 'react';

import I18n from '../../../lib/i18n';
import ListImage from './ListImage';
import NewsText from './NewsText';

interface IProps {
  listImage: string;
  text: string;
  iconImage: string;
  movie: number;
  isDiscovery?: boolean;
}

const NewsListItemRead = (props: IProps) => {
  const { listImage, text, iconImage, movie, isDiscovery = false } = props;

  return (
    <div>
      <h4>{I18n.t('messages.preview.news_list_item_read')}</h4>
      <div className="news-list-item-read list-image-preview">
        <ListImage listImage={listImage} movie={movie} />
        <div className="news-list-item-read-title">
          <div className="list-news-icon-box">
            <img
              role="presentation"
              className="list-news-icon"
              src={`data:image/jpeg;base64,${iconImage}`} />
          </div>
          <NewsText text={text} className={isDiscovery ? 'news-list-item-read-text-for-discovery' : 'news-list-item-read-text'} />
        </div>
      </div>
    </div>
  );
};

export default NewsListItemRead;